<template>
   <el-dialog
      :title="strategyDialogTitle"
      v-model="visibleProxy"
      width="1100px"
      :modal-append-to-body="false"
      custom-class="ad-add-strategy-dialog"
      :close-on-click-modal="false"
      @closed="handleDialogClosed"
   >
      <div class="strategy-dialog-body">
         <div class="strategy-dialog-form">
            <el-form :model="addForm" ref="addFormRef" label-position="left" label-width="110px">
               <el-form-item>
                  <template slot="label">
                     <span class="required">*</span> 策略名称
                  </template>
                  <div class="strategy-name-row">
                     <el-input
                        v-model="addForm.name"
                        placeholder="请输入策略名称"
                        clearable
                        @blur="validateStrategyName"
                     />
                     <div v-if="isDuplicateStrategyName" class="strategy-name-duplicate-tip">
                        策略名称不允许重复
                     </div>
                  </div>
               </el-form-item>

               <el-form-item>
                  <template slot="label">
                     <span class="required">*</span> 生效时间
                  </template>
                  <div class="effect-time-row">
                     <div class="form-radio-group">
                        <el-radio v-model="addForm.effectTimeType" label="forever">永久</el-radio>
                        <el-radio v-model="addForm.effectTimeType" label="range">有效期</el-radio>
                     </div>
                     <div v-if="addForm.effectTimeType === 'range'" class="effect-time-range">
                        <el-date-picker
                           v-model="addForm.effectStart"
                           type="datetime"
                           placeholder="选择开始日期/时间"
                           format="yyyy-MM-dd HH:mm:ss"
                           value-format="yyyy-MM-dd HH:mm:ss"
                           :clearable="false"
                        />
                        <span class="range-sep">-</span>
                        <el-date-picker
                           v-model="addForm.effectEnd"
                           type="datetime"
                           placeholder="选择结束日期/时间"
                           format="yyyy-MM-dd HH:mm:ss"
                           value-format="yyyy-MM-dd HH:mm:ss"
                           :clearable="false"
                        />
                     </div>
                  </div>
               </el-form-item>

               <el-form-item>
                  <template slot="label">
                     <span class="required">*</span> 生效系统
                  </template>
                  <el-radio-group v-model="addForm.systemType">
                     <el-radio label="all">全部</el-radio>
                     <el-radio label="ios">iOS</el-radio>
                     <el-radio label="hongmeng">鸿蒙</el-radio>
                     <el-radio label="android">安卓</el-radio>
                  </el-radio-group>
               </el-form-item>

               <div class="section-title"><span class="required">*</span> APP广告位</div>

               <div class="app-ad-split">
                  <div class="app-ad-row">
                     <div class="app-ad-left"><span class="required">*</span> 开屏</div>
                     <div class="app-ad-switch">
                        <el-switch
                           v-model="addForm.appAds.openSplash.enabled"
                           active-color="#409eff"
                           inactive-color="#c0c4cc"
                        />
                     </div>
                  </div>
                  <div v-if="addForm.appAds.openSplash.enabled" class="interval-grid">
                     <div class="interval-line">
                        <div class="interval-label">冷启动间隔</div>
                        <el-input-number
                           v-model="addForm.appAds.openSplash.cold"
                           :min="0"
                           :max="9999"
                           :step="1"
                           :precision="0"
                           controls-position="right"
                        />
                        <el-select v-model="addForm.appAds.openSplash.coldUnit" size="mini" class="interval-unit">
                           <el-option label="秒" value="sec" />
                           <el-option label="分钟" value="min" />
                           <el-option label="小时" value="hour" />
                           <el-option label="天" value="day" />
                        </el-select>
                     </div>
                     <div class="interval-line">
                        <div class="interval-label">热启动间隔</div>
                        <el-input-number
                           v-model="addForm.appAds.openSplash.hot"
                           :min="0"
                           :max="9999"
                           :step="1"
                           :precision="0"
                           controls-position="right"
                        />
                        <el-select v-model="addForm.appAds.openSplash.hotUnit" size="mini" class="interval-unit">
                           <el-option label="秒" value="sec" />
                           <el-option label="分钟" value="min" />
                           <el-option label="小时" value="hour" />
                           <el-option label="天" value="day" />
                        </el-select>
                     </div>
                  </div>
               </div>

               <div class="app-ad-split">
                  <div class="app-ad-row">
                     <div class="app-ad-left"><span class="required">*</span> 首页-插屏</div>
                     <div class="app-ad-switch">
                        <el-switch
                           v-model="addForm.appAds.homePop.enabled"
                           active-color="#409eff"
                           inactive-color="#c0c4cc"
                        />
                     </div>
                  </div>
                  <div v-if="addForm.appAds.homePop.enabled" class="interval-grid">
                     <div class="interval-line">
                        <div class="interval-label">冷启动间隔</div>
                        <el-input-number
                           v-model="addForm.appAds.homePop.cold"
                           :min="0"
                           :max="9999"
                           :step="1"
                           :precision="0"
                           controls-position="right"
                        />
                        <el-select v-model="addForm.appAds.homePop.coldUnit" size="mini" class="interval-unit">
                           <el-option label="秒" value="sec" />
                           <el-option label="分钟" value="min" />
                           <el-option label="小时" value="hour" />
                           <el-option label="天" value="day" />
                        </el-select>
                     </div>
                     <div class="interval-line">
                        <div class="interval-label">热启动间隔</div>
                        <el-input-number
                           v-model="addForm.appAds.homePop.hot"
                           :min="0"
                           :max="9999"
                           :step="1"
                           :precision="0"
                           controls-position="right"
                        />
                        <el-select v-model="addForm.appAds.homePop.hotUnit" size="mini" class="interval-unit">
                           <el-option label="秒" value="sec" />
                           <el-option label="分钟" value="min" />
                           <el-option label="小时" value="hour" />
                           <el-option label="天" value="day" />
                        </el-select>
                     </div>
                  </div>
               </div>

               <div class="app-ad-split">
                  <div class="app-ad-row">
                     <div class="app-ad-left"><span class="required">*</span> 跑步结束-插屏</div>
                     <div class="app-ad-switch">
                        <el-switch
                           v-model="addForm.appAds.runEndPop.enabled"
                           active-color="#409eff"
                           inactive-color="#c0c4cc"
                        />
                     </div>
                  </div>
                  <div v-if="addForm.appAds.runEndPop.enabled" class="interval-grid">
                     <div class="interval-line">
                        <div class="interval-label">冷启动间隔</div>
                        <el-input-number
                           v-model="addForm.appAds.runEndPop.cold"
                           :min="0"
                           :max="9999"
                           :step="1"
                           :precision="0"
                           controls-position="right"
                        />
                        <el-select v-model="addForm.appAds.runEndPop.coldUnit" size="mini" class="interval-unit">
                           <el-option label="秒" value="sec" />
                           <el-option label="分钟" value="min" />
                           <el-option label="小时" value="hour" />
                           <el-option label="天" value="day" />
                        </el-select>
                     </div>
                     <div class="interval-line">
                        <div class="interval-label">热启动间隔</div>
                        <el-input-number
                           v-model="addForm.appAds.runEndPop.hot"
                           :min="0"
                           :max="9999"
                           :step="1"
                           :precision="0"
                           controls-position="right"
                        />
                        <el-select v-model="addForm.appAds.runEndPop.hotUnit" size="mini" class="interval-unit">
                           <el-option label="秒" value="sec" />
                           <el-option label="分钟" value="min" />
                           <el-option label="小时" value="hour" />
                           <el-option label="天" value="day" />
                        </el-select>
                     </div>
                  </div>
               </div>

               <div class="app-ad-row">
                  <div class="app-ad-left"><span class="required">*</span> 首页-信息流</div>
                  <div class="app-ad-switch">
                     <el-switch
                        v-model="addForm.appAds.homeFeed.enabled"
                        active-color="#409eff"
                        inactive-color="#c0c4cc"
                     />
                  </div>
               </div>

               <div class="app-ad-row">
                  <div class="app-ad-left"><span class="required">*</span> 跑步结束-信息流</div>
                  <div class="app-ad-switch">
                     <el-switch
                        v-model="addForm.appAds.runEndFeed.enabled"
                        active-color="#409eff"
                        inactive-color="#c0c4cc"
                     />
                  </div>
               </div>

               <div class="app-ad-row">
                  <div class="app-ad-left"><span class="required">*</span> 我的-信息流</div>
                  <div class="app-ad-switch">
                     <el-switch
                        v-model="addForm.appAds.mineFeed.enabled"
                        active-color="#409eff"
                        inactive-color="#c0c4cc"
                     />
                  </div>
               </div>

               <div class="app-ad-row">
                  <div class="app-ad-left"><span class="required">*</span> 悬浮窗</div>
                  <div class="app-ad-switch">
                     <el-switch
                        v-model="addForm.appAds.floatingWindow.enabled"
                        active-color="#409eff"
                        inactive-color="#c0c4cc"
                     />
                  </div>
               </div>

               <div class="section-divider" />

               <el-form-item>
                  <template slot="label">
                     <span class="required">*</span> 适用人群
                  </template>
                  <div class="crowd-options">
                     <div
                        v-for="opt in crowdOptions"
                        :key="opt.id"
                        class="crowd-option"
                        :class="{ 'is-selected': isCrowdSelected(opt.id) }"
                        @click="handleSelectCrowd(opt.id)"
                     >
                        {{ opt.name }}
                     </div>
                  </div>
               </el-form-item>

               <el-form-item>
                  <template slot="label">
                     <span class="required">*</span> 适用校区
                  </template>
                  <el-radio-group v-model="addForm.campusScope">
                     <el-radio label="all">全部</el-radio>
                     <el-radio label="partial">部分校区配置</el-radio>
                  </el-radio-group>
                  <div v-if="addForm.campusScope === 'partial'" class="campus-partial">
                     <div class="campus-select-row">
                        <el-select
                           v-model="campusForm.unid"
                           placeholder="请选择校区"
                           filterable
                           class="campus-select"
                        >
                           <el-option
                              v-for="item in effectiveCampusZoneList"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                           />
                        </el-select>
                        <el-button type="primary" class="campus-add-btn" @click="handleAddCampusZones">添加</el-button>
                     </div>

                     <div class="campus-card-wrap">
                        <div
                           v-for="item in campusModels"
                           :key="item.unid"
                           class="campus-dialog-item"
                        >
                           <span>{{ item.name }}</span>
                           <el-button type="text" icon="circle-close" @click="handleDeleteCampus(item.unid)"></el-button>
                        </div>
                     </div>

                     <div class="campus-card-footer">
                        共 {{ campusModels.length }} 个校区
                     </div>
                  </div>
               </el-form-item>
            </el-form>
         </div>
      </div>

      <span slot="footer" class="dialog-footer">
         <el-button @click="visibleProxy = false">取消</el-button>
         <el-button type="primary" @click="handleSaveAddStrategy">保存</el-button>
      </span>
   </el-dialog>
</template>

<script>
const API_SUCCESS = 10000;

const defaultAddForm = () => ({
   name: "",
   effectTimeType: "forever", // forever | range
   effectStart: "",
   effectEnd: "",
   systemType: "all", // all | ios | hongmeng | android
   campusScope: "all", // all | partial
   campusUnids: [],
   crowdIds: [],
   appAds: {
      openSplash: { enabled: true, cold: 0, hot: 60, coldUnit: "sec", hotUnit: "sec" },
      homePop: { enabled: true, cold: 0, hot: 60, coldUnit: "sec", hotUnit: "sec" },
      runEndPop: { enabled: true, cold: 0, hot: 60, coldUnit: "sec", hotUnit: "sec" },
      homeFeed: { enabled: true },
      runEndFeed: { enabled: true },
      mineFeed: { enabled: true },
      floatingWindow: { enabled: true },
   },
});

export default {
   name: "AdAddStrategyDialog",
   props: {
      visible: {
         type: Boolean,
         default: false,
      },
      existingStrategyNames: {
         type: Array,
         default: () => [],
      },
      CampusZoneList: {
         type: Array,
         default: () => [],
      },
      /** 有值且 >0 时为编辑，保存时带 id；新建不传 id */
      editStrategyId: {
         default: null,
         validator(v) {
            return v === null || v === undefined || (typeof v === "number" && !Number.isNaN(v));
         },
      },
      /** 编辑时当前策略名，从「重名」列表中排除，避免误报与自身重名 */
      duplicateNameExclude: {
         type: String,
         default: "",
      },
      /** 「复制」时父组件传入的详情 DTO，打开弹窗后写入表单并清空策略名，消费后 .sync 置空 */
      strategyPrefillDto: {
         default: null,
         validator(v) {
            return v === null || v === undefined || (typeof v === "object" && !Array.isArray(v));
         },
      },
   },
   data() {
      return {
         crowdOptions: [],
         addForm: defaultAddForm(),
         campusForm: {
            unid: "",
         },
         campusModels: [],
      };
   },
   computed: {
      visibleProxy: {
         get() {
            return this.visible;
         },
         set(val) {
            this.$emit("update:visible", val);
         },
      },
      strategyDialogTitle() {
         return this.isEditMode ? "编辑广告策略" : "新增广告策略";
      },
      isEditMode() {
         return this.editStrategyId != null && this.editStrategyId > 0;
      },
      // 策略名称重复提示（UI 模拟）
      isDuplicateStrategyName() {
         const name = (this.addForm.name || "").trim();
         if (!name) return false;
         const exclude = (this.duplicateNameExclude || "").trim();
         const list = (this.existingStrategyNames || []).filter((n) => n !== exclude);
         return list.includes(name);
      },
      currentOperatorId() {
         const u = this.$store.state.user;
         const id = u && u.userId;
         const n = Number(id);
         return Number.isFinite(n) ? n : 0;
      },
      effectiveCampusZoneList() {
         return this.CampusZoneList || [];
      },
      hasStrategyPrefill() {
         const p = this.strategyPrefillDto;
         return p != null && typeof p === "object" && !Array.isArray(p);
      },
   },
   watch: {
      visible(val) {
         if (val) {
            this.loadCrowdOptions();
            if (this.isEditMode) {
               this.loadStrategyDetail(this.editStrategyId);
            } else if (this.hasStrategyPrefill) {
               this.applyStrategyDtoToAddForm(this.strategyPrefillDto);
               this.addForm.name = "";
               this.$emit("update:strategyPrefillDto", null);
            } else {
               this.resetAddStrategyForm();
            }
         }
      },
   },
   methods: {
      /** 有效期：兼容 string 与 Date（避免对 Date 调用 trim） */
      normalizeEffectDateTime(val) {
         if (val == null || val === "") return "";
         if (val instanceof Date) {
            if (Number.isNaN(val.getTime())) return "";
            const pad = (n) => String(n).padStart(2, "0");
            return `${val.getFullYear()}-${pad(val.getMonth() + 1)}-${pad(val.getDate())} ${pad(val.getHours())}:${pad(val.getMinutes())}:${pad(val.getSeconds())}`;
         }
         const s = String(val).trim();
         if (!s) return "";
         if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}$/.test(s)) return `${s}:00`;
         return s;
      },
      normalizeListResponse(data) {
         if (!data) return [];
         if (Array.isArray(data)) return data;
         if (Array.isArray(data.list)) return data.list;
         return [];
      },
      unitUiToApi(unit) {
         const map = { sec: 1, min: 2, hour: 3, day: 4 };
         return map[unit] || 1;
      },
      buildOneSlot(slotType, cfg) {
         const isPop = slotType >= 1 && slotType <= 3;
         const enabled = cfg && cfg.enabled;
         if (!isPop) {
            return {
               slotType,
               isShow: enabled ? 1 : 0,
               coldStartInterval: 0,
               coldStartUnit: 1,
               hotStartInterval: 0,
               hotStartUnit: 1,
            };
         }
         return {
            slotType,
            isShow: enabled ? 1 : 0,
            coldStartInterval: enabled ? (cfg.cold != null ? cfg.cold : 0) : 0,
            coldStartUnit: this.unitUiToApi(cfg.coldUnit || "sec"),
            hotStartInterval: enabled ? (cfg.hot != null ? cfg.hot : 0) : 0,
            hotStartUnit: this.unitUiToApi(cfg.hotUnit || "sec"),
         };
      },
      buildStrategySaveBodyFromAddForm() {
         const ads = this.addForm.appAds || {};
         const slotConfigs = [
            this.buildOneSlot(1, ads.openSplash),
            this.buildOneSlot(2, ads.homePop),
            this.buildOneSlot(3, ads.runEndPop),
            this.buildOneSlot(4, { enabled: ads.homeFeed && ads.homeFeed.enabled }),
            this.buildOneSlot(5, { enabled: ads.runEndFeed && ads.runEndFeed.enabled }),
            this.buildOneSlot(6, { enabled: ads.mineFeed && ads.mineFeed.enabled }),
            this.buildOneSlot(7, { enabled: ads.floatingWindow && ads.floatingWindow.enabled }),
         ];
         const systemMap = { all: 0, ios: 1, hongmeng: 2, android: 3 };
         const campusScopeMap = { all: 1, partial: 2 };
         const effectiveTimeType = this.addForm.effectTimeType === "range" ? 2 : 1;
         const body = {
            strategyName: (this.addForm.name || "").trim(),
            effectiveTimeType,
            effectiveStartTime:
               effectiveTimeType === 2 ? this.normalizeEffectDateTime(this.addForm.effectStart) : "",
            effectiveEndTime:
               effectiveTimeType === 2 ? this.normalizeEffectDateTime(this.addForm.effectEnd) : "",
            effectiveSystem:
               systemMap[this.addForm.systemType] != null ? systemMap[this.addForm.systemType] : 0,
            campusScope:
               campusScopeMap[this.addForm.campusScope] != null
                  ? campusScopeMap[this.addForm.campusScope]
                  : 1,
            slotConfigs,
            crowdIds: this.addForm.crowdIds || [],
            campusIds:
               this.addForm.campusScope === "partial"
                  ? (this.campusModels || []).map((m) => Number(m.unid)).filter((n) => !Number.isNaN(n))
                  : [],
            operator: this.currentOperatorId,
         };
         if (this.isEditMode) {
            body.id = this.editStrategyId;
         }
         return body;
      },
      loadStrategyDetail(id) {
         this.$http({
            url: `${this.$util.domain}/adminapi/v1/ad/strategy/detail/${id}`,
            method: "GET",
         })
            .then((res) => {
               if (!this.visibleProxy || this.editStrategyId !== id) return;
               if (res.body.error !== API_SUCCESS || !res.body.data) {
                  console.warn("[AdAddStrategyDialog] loadStrategyDetail fail", res.body);
                  this.$message({
                     type: "error",
                     message: res.body.message || "加载策略详情失败",
                  });
                  this.visibleProxy = false;
                  return;
               }
               if (this.editStrategyId !== id || !this.visibleProxy) return;
               this.applyStrategyDtoToAddForm(res.body.data);
            })
            .catch(() => {
               if (!this.visibleProxy || this.editStrategyId !== id) return;
               console.warn("[AdAddStrategyDialog] loadStrategyDetail network error");
               this.$message({
                  type: "error",
                  message: "网络异常，策略详情加载失败",
               });
               this.visibleProxy = false;
            });
      },
      applyStrategyDtoToAddForm(dto) {
         const base = defaultAddForm();
         base.name = dto.strategyName || "";
         base.effectTimeType = dto.effectiveTimeType === 2 ? "range" : "forever";
         base.effectStart =
            dto.effectiveStartTime != null && String(dto.effectiveStartTime).trim()
               ? String(dto.effectiveStartTime).trim()
               : "";
         base.effectEnd =
            dto.effectiveEndTime != null && String(dto.effectiveEndTime).trim()
               ? String(dto.effectiveEndTime).trim()
               : "";
         const sysRev = { 0: "all", 1: "ios", 2: "hongmeng", 3: "android" };
         base.systemType = sysRev[dto.effectiveSystem] != null ? sysRev[dto.effectiveSystem] : "all";
         base.campusScope = dto.campusScope === 2 ? "partial" : "all";
         base.crowdIds = (dto.crowdIds || [])
            .map((c) => (c && typeof c === "object" ? c.id : c))
            .filter((x) => x != null);

         const slotByType = {};
         (dto.slotConfigs || []).forEach((s) => {
            if (s && s.slotType != null) slotByType[s.slotType] = s;
         });
         const unitRev = (u) => ({ 1: "sec", 2: "min", 3: "hour", 4: "day" }[u] || "sec");
         const popSlot = (t) => {
            const s = slotByType[t];
            if (t <= 3) {
               if (!s) return { enabled: true, cold: 0, hot: 60, coldUnit: "sec", hotUnit: "sec" };
               return {
                  enabled: s.isShow === 1,
                  cold: s.coldStartInterval != null ? s.coldStartInterval : 0,
                  hot: s.hotStartInterval != null ? s.hotStartInterval : 0,
                  coldUnit: unitRev(s.coldStartUnit),
                  hotUnit: unitRev(s.hotStartUnit),
               };
            }
            return { enabled: !s || s.isShow === 1 };
         };
         base.appAds = {
            openSplash: popSlot(1),
            homePop: popSlot(2),
            runEndPop: popSlot(3),
            homeFeed: popSlot(4),
            runEndFeed: popSlot(5),
            mineFeed: popSlot(6),
            floatingWindow: popSlot(7),
         };

         this.addForm = base;
         this.campusModels = (dto.campusIds || []).map((c) => ({
            unid: c.id,
            name: c.campusName || String(c.id),
         }));
         this.campusForm.unid = "";
      },
      loadCrowdOptions() {
         this.$http({
            url: this.$util.domain + "/adminapi/v1/ad/crowd/all",
            method: "GET",
         })
            .then((res) => {
               if (res.body.error !== API_SUCCESS) {
                  this.crowdOptions = [];
                  return;
               }
               const raw = this.normalizeListResponse(res.body.data);
               const list = raw.length ? raw : res.body.data && res.body.data.id != null ? [res.body.data] : [];
               this.crowdOptions = list
                  .map((c) => ({
                     id: c.id,
                     name: c.crowdName || "",
                  }))
                  .filter((x) => x.id != null && x.name);
            })
            .catch(() => {
               this.crowdOptions = [];
            });
      },
      resetAddStrategyForm() {
         this.addForm = defaultAddForm();
         this.campusForm.unid = "";
         this.campusModels = [];
      },
      validateStrategyName() {
         // UI 模拟：重复校验由 computed `isDuplicateStrategyName` 完成
      },
      isCrowdSelected(id) {
         return (this.addForm.crowdIds || []).includes(id);
      },
      handleSelectCrowd(id) {
         const ids = this.addForm.crowdIds || [];
         if (this.isCrowdSelected(id)) {
            this.addForm.crowdIds = ids.filter((x) => x !== id);
         } else {
            this.addForm.crowdIds = [...ids, id];
         }
      },
      handleSaveAddStrategy() {
         const name = (this.addForm.name || "").trim();
         if (!name) return this.$message.warning("请输入策略名称");
         if (this.isDuplicateStrategyName) return this.$message.warning("策略名称不允许重复");
         if (!(this.addForm.crowdIds || []).length) return this.$message.warning("请至少选择一个适用人群");
         if (this.addForm.campusScope === "partial" && !this.campusModels.length) {
            return this.$message.warning("请至少添加一个校区");
         }
         if (this.addForm.effectTimeType === "range") {
            if (
               !this.normalizeEffectDateTime(this.addForm.effectStart) ||
               !this.normalizeEffectDateTime(this.addForm.effectEnd)
            ) {
               return this.$message.warning("请选择有效期开始与结束时间");
            }
         }

         const body = this.buildStrategySaveBodyFromAddForm();
         this.$http({
            url: this.$util.domain + "/adminapi/v1/ad/strategy/save",
            method: "POST",
            dataType: "json",
            body: JSON.stringify(body),
         })
            .then((res) => {
               if (res.body.error !== API_SUCCESS) {
                  this.$message({
                     type: "error",
                     message: res.body.message || "保存失败",
                  });
                  return;
               }
               this.$message({
                  type: "success",
                  message: "操作成功!",
               });
               this.$emit("saved");
               this.visibleProxy = false;
            })
            .catch(() => {
               this.$message({
                  type: "error",
                  message: "操作失败，请稍后再试!",
               });
            });
      },
      handleDialogClosed() {
         this.resetAddStrategyForm();
      },

      handleAddCampusZones() {
         if (!this.campusForm.unid) return;
         const exists = this.campusModels.find((item) => item.unid === this.campusForm.unid);
         if (exists) return;

         const f = this.effectiveCampusZoneList.find((item) => item.value === this.campusForm.unid);
         if (!f) return;

         this.campusModels.push({ unid: f.value, name: f.label });
         this.campusForm.unid = "";
      },

      handleDeleteCampus(unid) {
         this.campusModels = this.campusModels.filter((item) => item.unid !== unid);
      },
   },
};
</script>

<style scoped>
.strategy-dialog-body {
  padding: 4px 0;
}

.strategy-dialog-form {
  padding: 0 6px;
}

.required {
  color: #f56c6c;
  font-weight: 600;
  margin-right: 4px;
}

.strategy-name-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.strategy-name-duplicate-tip {
  color: #f56c6c;
  font-size: 12px;
  white-space: nowrap;
}

.form-radio-group {
  display: flex;
  gap: 20px;
  align-items: center;
  flex-wrap: nowrap;
  white-space: nowrap;
}

.effect-time-row {
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: nowrap;
}

.effect-time-range {
  display: flex;
  align-items: center;
  gap: 10px;
}

.range-sep {
  color: #606266;
}

.section-title {
  font-weight: 600;
  margin: 18px 0 10px;
}

.section-divider {
  height: 1px;
  background: #ebeef5;
  margin: 18px 0;
}

.app-ad-row {
  display: flex;
  align-items: center;
  gap: 14px;
  white-space: nowrap;
  flex-shrink: 0;
}

/* 同一组中相邻行之间加纵向间距（例如首页信息流 -> 跑步结束信息流 -> 我的信息流） */
.app-ad-row + .app-ad-row {
  margin-top: 12px;
}

.app-ad-split {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 12px;
}

.app-ad-left {
  font-size: 13px;
  width: 150px;
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
}

.app-ad-switch {
  flex-shrink: 0;
}

.interval-grid {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.interval-line {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.interval-label {
  width: 120px;
  flex-shrink: 0;
  color: #606266;
  font-size: 13px;
}

.interval-unit {
  flex-shrink: 0;
  width: 80px;
}

.interval-unit-text {
  color: #606266;
  font-size: 13px;
  flex-shrink: 0;
}

.crowd-options {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 12px;
  align-items: flex-start;
}

.crowd-option {
  border: 1px solid #c0ccda;
  border-radius: 4px;
  padding: 6px 10px;
  font-size: 13px;
  line-height: 1.3;
  cursor: pointer;
  user-select: none;
  background: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.crowd-option.is-selected {
  border-color: #409eff;
  color: #409eff;
  background: #ecf5ff;
}

.campus-hint {
  margin-top: 6px;
  color: #909399;
  font-size: 12px;
}

.campus-partial {
  margin-top: 10px;
}

.campus-select-row {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 10px;
  padding-right: 18px;
}

.campus-select {
  flex: 0 0 84%;
  max-width: 84%;
}

.campus-add-btn {
  min-width: 84px;
  height: 40px;
  padding: 0 20px;
  font-size: 16px;
  margin-left: 4px;
  margin-right: 6px;
}

.campus-card-wrap {
  box-sizing: border-box;
  width: 100%;
  height: 200px;
  overflow: auto;
  padding: 10px;
  border: 1px solid #c0ccda;
  border-radius: 4px;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  gap: 8px;
}

.campus-dialog-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 1px solid #c0ccda;
  border-radius: 4px;
  padding: 4px 6px;
  font-size: 13px;
  line-height: 1.3;
  background: #fff;
}

.campus-card-footer {
  text-align: right;
  color: #909399;
  font-size: 13px;
  margin-top: 8px;
}

/* 弹框底部按钮：垂直居中 + 组件间距 */
.dialog-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
}
</style>




// WEBPACK FOOTER //
// AdAddStrategyDialog.vue?61fe64ee